var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play--outline",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29124",
    "data-name": "Path 29124",
    d: "M10.579,17.1A.579.579,0,0,1,10,16.521V9.579a.579.579,0,0,1,.837-.518l5.143,3.471a.579.579,0,0,1,0,1.035l-5.143,3.471a.579.579,0,0,1-.259.061Z",
    transform: "translate(-1.057 -2.05)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29125",
    "data-name": "Path 29125",
    d: "M11,3.286A7.714,7.714,0,1,1,3.286,11,7.714,7.714,0,0,1,11,3.286M11,2a9,9,0,1,0,9,9,9,9,0,0,0-9-9Z",
    fill: "#203662"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewNew);
export default __webpack_public_path__ + "static/media/PreviewNew.81092c463f8badf4d787a366b364d821.svg";
export { ForwardRef as ReactComponent };